import { FuelType } from 'models/FuelType';

export class FuelStop {
    id: number;
    fuelType: FuelType;
    quantity: number;
    archivedDate?: Date;

    constructor (
        id:number,
        fuelType: FuelType,
        quantity: number,
        archivedDate?: Date
    ) {
        this.id = id;
        this.fuelType = fuelType;
        this.quantity = quantity;
        this.archivedDate = archivedDate;
    }

    static empty(): FuelStop {
        return { 
            id: 0,
            fuelType: FuelType.empty(),
            quantity: 0
        };
    }
}